import React from "react";
import { connect } from "react-redux";
import _, { get } from "lodash";
import PropTypes from "prop-types";
import { Map } from "immutable";
import removeKey from "LIB/removeKey";
import {
  ADMIN,
  CAN_RELEASE_SHIPMENT,
  QUALITY_CONTROL,
  ROLE,
  USER
} from "MODULES/users/constants";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { updateROLineItem } from "MODULES/RepairOrders/actions";
import {
  CORE_RETURN_FEE_SAVINGS,
  SHOP_ASSIST
} from "MODULES/RepairOrders/constants";
import { OTHER, OTHER_TAG_TYPE } from "MODULES/inventories/constants";
import { coreReturnFeeSavingsVal } from "MODULES/RepairOrders/helpers";
import { formValueSelector } from "redux-form";
import { StatusTag } from "MODULES/shared/components";
import Form from "./Form";

const FORM_NAME = "repairOrderLineItem";

export function Edit({
  askingAfterInternalOutright,
  canOverrideReadOnly,
  readOnly,
  open,
  close,
  lineItem = {},
  repairOrder,
  onSubmit,
  canReleaseForShipment
}) {
  const internalOutrightId = get(
    lineItem,
    "inventory.internal_outright_sales_item_id"
  );
  const mostRecentSalesItemId = get(
    lineItem,
    "inventory.most_recent_sales_order.sales_item_id"
  );
  const reclaimed = get(lineItem, "inventory.reclaimed");

  const shouldAskInternalOutright =
    internalOutrightId === mostRecentSalesItemId;

  const shopAssistValues = () => {
    if (lineItem && lineItem.action_requested === SHOP_ASSIST) {
      return {
        id: lineItem.shop_assist_repair_order_id,
        code: lineItem.shop_assist_repair_order_code
      };
    }
    return null;
  };
  const filteredInitialValues = canReleaseForShipment
    ? lineItem
    : removeKey(lineItem, "release_for_shipment");

  filteredInitialValues[OTHER] =
    filteredInitialValues[OTHER_TAG_TYPE] &&
    filteredInitialValues[OTHER_TAG_TYPE].length > 0;

  filteredInitialValues[CORE_RETURN_FEE_SAVINGS] = coreReturnFeeSavingsVal(
    lineItem.flat_exchange
      ? lineItem.not_to_exceed
      : lineItem.original_evaluation,
    lineItem.subtotal
  );

  return (
    <div>
      <Modal open={open} close={close} dialogClass="modal-lg">
        <Header>
          <Close close={close} />
          <h4 className="modal-title">
            {askingAfterInternalOutright
              ? "Internal Outright Cost Application"
              : "Edit a Part"}
            {reclaimed && (
              <span style={{ marginLeft: "10px" }}>
                <StatusTag
                  display="warning"
                  title="Reclaimed"
                  icon="superpowers"
                />
              </span>
            )}
          </h4>
        </Header>
        <Form
          onSubmit={onSubmit}
          close={close}
          initialValues={filteredInitialValues}
          repairOrder={repairOrder}
          lineItem={lineItem}
          editing
          readOnly={readOnly && !canOverrideReadOnly}
          shopAssistRepairOrder={shopAssistValues()}
          shouldAskInternalOutright={shouldAskInternalOutright}
          part={{
            id: get(lineItem, "part.id"),
            part_number: get(lineItem, "part.part_number"),
            tier_type: get(lineItem, "part.tier_type")
          }}
          modTo={{
            id: get(lineItem, "mod_to.id"),
            part_number: get(lineItem, "mod_to.part_number")
          }}
        />
      </Modal>
    </div>
  );
}

Edit.propTypes = {
  askingAfterInternalOutright: PropTypes.bool,
  canOverrideReadOnly: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool,
  open: PropTypes.bool,
  close: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  repairOrder: PropTypes.instanceOf(Map),
  lineItem: PropTypes.shape({}),
  canReleaseForShipment: PropTypes.bool
};

export default connect(
  state => ({
    askingAfterInternalOutright: formValueSelector(FORM_NAME)(
      state,
      "asking_internal_outright"
    ),
    canReleaseForShipment:
      state.session.getIn([USER, ROLE]) === ADMIN ||
      state.session.getIn([USER, CAN_RELEASE_SHIPMENT]),
    canOverrideReadOnly: [ADMIN, QUALITY_CONTROL].includes(
      state.session.getIn([USER, ROLE])
    ),
    getFieldValue: field => formValueSelector(FORM_NAME)(state, field)
  }),
  (dispatch, ownProps) => ({
    onSubmit: data =>
      dispatch(updateROLineItem(ownProps.lineItem.id, data, ownProps))
  })
)(Edit);



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/Edit.jsx